// extracted by mini-css-extract-plugin
export const wrapper = "RHMP-module--wrapper--32x4F";
export const graphic = "RHMP-module--graphic--3YSKd";
export const graphicWrapper = "RHMP-module--graphicWrapper--N1mrX";